import React from 'react';
import { Check } from 'lucide-react';

export const FORMATION_PLANS = [
  { code: 'essential', name: 'Essential', price: 449, banking: false },
  { code: 'essential_plus', name: 'Essential Plus', price: 549, banking: true },
  { code: 'business', name: 'Business', price: 549, banking: false },
  { code: 'business_plus', name: 'Business Plus', price: 649, banking: true },
];

export const FormationPlanGrid = ({ selectedPlan, onSelectPlan }) => (
  <section className="grid gap-4 md:grid-cols-2">
    {FORMATION_PLANS.map((plan) => (
      <button
        key={plan.code}
        type="button"
        aria-pressed={selectedPlan === plan.code}
        onClick={() => onSelectPlan(plan.code)}
        className={`rounded-2xl border p-6 text-left transition ${
          selectedPlan === plan.code
            ? 'border-emerald-500 bg-emerald-50 ring-emerald-200 dark:bg-emerald-950/30 ring-2'
            : 'border-neutral-200 bg-white hover:border-neutral-400 dark:border-neutral-800 dark:bg-neutral-900'
        }`}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold text-neutral-950 dark:text-white">
              {plan.name}
            </h2>
            <p className="mt-1 text-2xl font-semibold text-neutral-950 dark:text-white">
              ${plan.price}
            </p>
          </div>
          {selectedPlan === plan.code && <Check className="text-emerald-600" />}
        </div>
        <p className="mt-4 text-sm text-neutral-600 dark:text-neutral-300">
          Formación de LLC, EIN y recordatorios de cumplimiento.
        </p>
        {plan.banking && (
          <p className="bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-200 mt-3 rounded-lg px-3 py-2 text-sm">
            Incluye asistencia para la solicitud de cuenta bancaria. La
            aprobación depende del banco.
          </p>
        )}
      </button>
    ))}
  </section>
);

export const FormationDraftDetails = ({ draft }) => (
  <section className="mt-6 rounded-2xl border border-neutral-200 bg-white p-7 dark:border-neutral-800 dark:bg-neutral-900">
    <h2 className="text-lg font-semibold text-neutral-950 dark:text-white">
      Datos recibidos
    </h2>
    <dl className="mt-4 grid gap-4 text-sm sm:grid-cols-2">
      <div>
        <dt className="text-neutral-500">Nombre solicitado</dt>
        <dd className="mt-1 font-medium text-neutral-950 dark:text-white">
          {draft.companyName}
        </dd>
      </div>
      <div>
        <dt className="text-neutral-500">Estado y entidad</dt>
        <dd className="mt-1 font-medium text-neutral-950 dark:text-white">
          {draft.formationState} · {draft.entityType}
        </dd>
      </div>
      <div>
        <dt className="text-neutral-500">Solicitante</dt>
        <dd className="mt-1 font-medium text-neutral-950 dark:text-white">
          {draft.founderName || 'Se completará en Rely'}
        </dd>
      </div>
      <div>
        <dt className="text-neutral-500">EIN</dt>
        <dd className="mt-1 font-medium text-neutral-950 dark:text-white">
          {draft.einRequested ? 'Incluido' : 'No solicitado'}
        </dd>
      </div>
    </dl>
    <p className="mt-4 text-sm text-neutral-600 dark:text-neutral-300">
      Después del pago podrás completar miembros, participación, direcciones y
      documentos desde tu dashboard.
    </p>
  </section>
);
